import { z } from 'zod'
import { api } from '@/lib/api/client'
import type { ChannelNavigation, NavigationChangedEvent } from '@/types/navigation'

/* `z.object` com strip (default): chave nova do back é descartada no parse, não
   derruba a leitura. Tempo em MILISSEGUNDOS — a presença é que usa segundos. */
const NavigationUserSchema = z.object({
  user_id: z.string().min(1),
  entered_at: z.number(),
})

const ChatContactSchema = z.object({
  id: z.string().min(1),
  name: z.string(),
})

const ChatNavigationSchema = z.object({
  protocol_id: z.string().min(1),
  contact: ChatContactSchema.nullable(),
  users: z.array(NavigationUserSchema),
})

const ChannelNavigationSchema = z.object({
  channel_id: z.string().min(1),
  users: z.array(NavigationUserSchema),
  // Back anterior ao bloco de chat não manda a chave: vazio, não erro.
  chats: z.array(ChatNavigationSchema).default([]),
})

const NavigationSnapshotSchema = z.object({
  channels: z.array(ChannelNavigationSchema),
})

/**
 * `action` é `z.enum` FECHADO de propósito, ao contrário dos enums de leitura da
 * casa (`z.string`): o evento é um COMANDO de patch, e ação desconhecida não tem
 * patch possível — descartar é o único desfecho honesto.
 */
const NavigationChangedSchema = z.object({
  user_id: z.string().min(1),
  channel_id: z.string().min(1),
  protocol_id: z.string().nullable().optional(),
  contact: ChatContactSchema.nullable().optional(),
  action: z.enum(['enter', 'leave']),
  at: z.number(),
})

/**
 * `GET /users/navigation` — exige `users:navigation:read`. 403/404 sobem como
 * `ApiError` (interceptor do `api`); quem degrada pra vazio é o hook
 * (`useNavigationSnapshot`), não este módulo. Payload fora do contrato ESTOURA.
 */
export async function fetchNavigation(): Promise<ChannelNavigation[]> {
  const { data } = await api.get<unknown>('/users/navigation')
  return NavigationSnapshotSchema.parse(data).channels
}

/** Fronteira do socket: `null` = descartar o evento. Nunca lança dentro de handler. */
export function parseNavigationChanged(raw: unknown): NavigationChangedEvent | null {
  const lido = NavigationChangedSchema.safeParse(raw)
  return lido.success ? lido.data : null
}
